import { useId } from "react";
import { useQuestionizerStore } from "../types/state.ts";

export default function InputGrundversorger (props: {id: number, label: string, onBlur?: ()=>void}){
  //const grundversorger = useQuestionizerStore((state) => state.grundversorger);
  //const setGrundversorger = useQuestionizerStore((state) => state.setGrundversorger);
  const updateValidation = useQuestionizerStore((state) => state.updateValidation);
  const id = useId();

  return <div className={"input-"+props.id}>
    <label id={id}>{props.label}</label>
    <input aria-labelledby={id} type="text" value={""} onBlur={props.onBlur} onChange={()=>{
      updateValidation();
    }}/>
  </div>
}